import { FC } from "react";

import { Box, HStack } from "@chakra-ui/react";

import { Divider, FullWidthVStack } from "@components/common";
import { Desktop } from "@lib/media";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderStep } from "../../constants";
import useCommonOrderSideEffects from "../../hooks/common/useCommonOrderSideEffects";
import useSenderSideEffects from "../../hooks/sender/useSenderSideEffects";
import OrderFooter from "../common/OrderFooter";
import OrderForm from "../common/OrderForm";
import OrderPrice from "../common/OrderPrice";
import ContactPerson from "./ContactPerson";
import DeliveryDetails from "./DeliveryDetails";
import SenderFormFields from "./SenderFormFields";
import TodaysPickup from "./TodaysPickup";

const Sender: FC = () => {
  useCommonOrderSideEffects(OrderStep.SenderDetails);
  useSenderSideEffects();

  return (
    <OrderForm style={{ height: "100%" }}>
      <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} height="100%">
        <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} flex="1">
          <HStack align="flex-start" spacing="1rem">
            <Box width={responsiveStyle({ mobile: "100%", desktop: "50%" })}>
              <SenderFormFields />
            </Box>
            <Desktop>
              {(className, renderChildren) => (
                <Box flex="1" pt="2.7rem" className={className}>
                  {renderChildren && <TodaysPickup />}
                </Box>
              )}
            </Desktop>
          </HStack>
          <DeliveryDetails />
          <ContactPerson />

          <Divider />
          <OrderPrice withPromo={false} />
        </FullWidthVStack>
        <OrderFooter currentStep={OrderStep.SenderDetails} />
      </FullWidthVStack>
    </OrderForm>
  );
};
export default Sender;
